import type { TableColumn } from "./workflows-table";

type Props<T> = {
  columns: TableColumn<T>[];
};

export const WorkflowsTableHeader = <T,>({ columns }: Props<T>) => (
  <thead>
    <tr>
      {columns.map((column) => (
        <th
          key={String(column.key)}
          className="sticky top-0 z-20 bg-gray-100 pt-7 pb-4 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-gray-300 after:content-['']"
        >
          {column.label}
        </th>
      ))}
    </tr>
  </thead>
);
